import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ISpecialNeedsStudent, ISpecialNeedsStaff } from '../models/specialNeeds';
import { ErrorService } from '../helpers/errorService';

type Envelope<T> = { has_error: boolean, message: string, data: T };

@Injectable({
    providedIn: 'root'
})
export class SpecialNeedsService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    // --- Students ---
    getStudents(buildingId: string): Observable<Envelope<ISpecialNeedsStudent[]>> {
        const url = environment.apiBaseUrl + endpoints.getSpecialNeedsStudents.replace(':buildingId', buildingId);
        return this.http.get<Envelope<ISpecialNeedsStudent[]>>(url).pipe(catchError(this.errorService.handleError));
    }

    createStudent(buildingId: string, data: Partial<ISpecialNeedsStudent>): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.createSpecialNeedsStudent.replace(':buildingId', buildingId);
        return this.http.post<Envelope<any>>(url, data).pipe(catchError(this.errorService.handleError));
    }

    updateStudent(buildingId: string, itemId: string, data: Partial<ISpecialNeedsStudent>): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.updateSpecialNeedsStudent.replace(':buildingId', buildingId).replace(':itemId', itemId);
        return this.http.put<Envelope<any>>(url, data).pipe(catchError(this.errorService.handleError));
    }

    deleteStudent(buildingId: string, itemId: string): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.deleteSpecialNeedsStudent.replace(':buildingId', buildingId).replace(':itemId', itemId);
        return this.http.delete<Envelope<any>>(url).pipe(catchError(this.errorService.handleError));
    }

    // --- Staff ---
    getStaff(buildingId: string): Observable<Envelope<ISpecialNeedsStaff[]>> {
        const url = environment.apiBaseUrl + endpoints.getSpecialNeedsStaff.replace(':buildingId', buildingId);
        return this.http.get<Envelope<ISpecialNeedsStaff[]>>(url).pipe(catchError(this.errorService.handleError));
    }

    createStaff(buildingId: string, data: Partial<ISpecialNeedsStaff>): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.createSpecialNeedsStaff.replace(':buildingId', buildingId);
        return this.http.post<Envelope<any>>(url, data).pipe(catchError(this.errorService.handleError));
    }

    updateStaff(buildingId: string, itemId: string, data: Partial<ISpecialNeedsStaff>): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.updateSpecialNeedsStaff.replace(':buildingId', buildingId).replace(':itemId', itemId);
        return this.http.put<Envelope<any>>(url, data).pipe(catchError(this.errorService.handleError));
    }

    deleteStaff(buildingId: string, itemId: string): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.deleteSpecialNeedsStaff.replace(':buildingId', buildingId).replace(':itemId', itemId);
        return this.http.delete<Envelope<any>>(url).pipe(catchError(this.errorService.handleError));
    }
}
